


















import { Component, Prop, Vue } from "vue-property-decorator";
    
@Component
export default class ProgressChart extends Vue {
  
  @Prop() private colors!: string[]
  @Prop() private values!: number[]
  @Prop() private percentages!: number[]
  @Prop() private labels!: string[]
  @Prop() private total!: number

  private openModal(selectedTab: number) {
    this.$emit('openModal', selectedTab)
  }
}

